module.exports = __webpack_public_path__ + "img/Production-mobilephonelabel.e871170f.jpg";